import { action, extendObservable } from "mobx";
import { observer } from "mobx-react";
import React, { Component } from "react";
import styled from "styled-components";
import rem from "../../utils/rem";
import BaseChevron from "../icons/Chevron";

const Chevron = BaseChevron`
  font-size: 80%;
  cursor: pointer;
`;

const FilterHeader = styled.div`
  font-size: ${props => (props.large ? rem(18) : rem(14))};
  font-weight: ${props => props.large && "bold"};
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  display: flex;
  justify-content: space-between;
  margin: 20px 0 10px 0;
  padding-bottom: 5px;
`;

class FilterGroup extends Component {
  constructor(props) {
    super(props);
    extendObservable(this, {
      showChildren: props.showChildren,
      updateShowChildren: action(() => {
        this.showChildren = !this.showChildren;
      })
    });
  }

  render() {
    const { children, title, large } = this.props;

    return (
      <div>
        <FilterHeader large={large}>
          <div>{title}</div>
          <Chevron
            direction={this.showChildren ? "down" : "up"}
            onClick={this.updateShowChildren}
          />
        </FilterHeader>
        {this.showChildren ? children : null}
      </div>
    );
  }
}

FilterGroup.defaultProps = {
  showChildren: true
};

export default observer(FilterGroup);



// WEBPACK FOOTER //
// ./src/components/filters/FilterGroup.js